<p-sidebar [visible]="isVisibleFilters()" position="right" [modal]="false" [showCloseIcon]="false" [transitionOptions]="'200ms'">
  <div class="filter_content">
    <div class="flex flex-between" style="align-items: unset!important; flex-direction: row; width: 100%; padding: 16px 16px 12px 16px; border-bottom: 1px solid #E5E5E5">
      <div class="filter_name" style="margin-right: auto;">
        Фільтр
      </div>
      <div style="margin-left: auto" class="flex-between flex">
        <div style="margin-right: 16px"><med-icon-history [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="filter.resetFilter('/supplies')"></med-icon-history></div>
        <div><med-icon-close [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="this.filter.showSuppliesFilter = false"></med-icon-close></div>
      </div>
    </div>
    <div style="width: 100%; padding-left: 16px; padding-right: 25px">
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Номер договору"
          label="Номер договору"
          [(ngModel)]="filter.supplies.agreementNum[0]"
          (focusout)="filter.suppliesStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-multi-select
          size="small"
          [hideClearBtn]="true"
          placeholder="{{ !filter.supplies.status.length ? 'Всі': 'Обрано фільтрів: ' + filter.supplies.status.length }}"
          label="Статус поставки"
          [options]="filter.suppliesOptions.statuses"
          [(ngModel)]="filter.supplies.status"
          (ngModelChange)="filter.suppliesStateChanged()"
        ></med-multi-select>
      </div>
      <div style="width: 100%;">
        <med-multi-select
          size="small"
          [hideClearBtn]="true"
          placeholder="{{ !filter.supplies.direction.length ? 'Всі': 'Обрано фільтрів: ' + filter.supplies.direction.length }}"
          label="Напрям"
          [options]="filter.suppliesOptions.directions"
          [(ngModel)]="filter.supplies.direction"
          (ngModelChange)="filter.suppliesStateChanged()"
        ></med-multi-select>
      </div>
      <div style="width: 100%;">
        <med-multi-select
          size="small"
          [hideClearBtn]="true"
          placeholder="{{ !filter.supplies.subDirection.length ? 'Всі': 'Обрано фільтрів: ' + filter.supplies.subDirection.length }}"
          label="Піднапрям"
          [options]="filter.suppliesOptions.subDirections"
          [(ngModel)]="filter.supplies.subDirection"
          (ngModelChange)="filter.suppliesStateChanged()"
        ></med-multi-select>
      </div>
      <div style="width: 100%;">
        <med-multi-select
          size="small"
          [hideClearBtn]="true"
          placeholder="{{ !filter.supplies.mnn.length ? 'Всі': 'Обрано фільтрів: ' + filter.supplies.mnn.length }}"
          label="МНН"
          [options]="filter.suppliesOptions.mnns"
          [(ngModel)]="filter.supplies.mnn"
          (ngModelChange)="filter.suppliesStateChanged()"
        ></med-multi-select>
      </div>
      <div style="width: 100%;">
        <med-datepicker
          size="small"
          [mode]="'range'"
          label="Очікувана дата поставки"
          placeholder="Оберіть дату"
          [(ngModel)]="filter.supplies.expectedDate"
          (onInput)="filter.suppliesStateChanged()"
        ></med-datepicker>
      </div>
      <div style="width: 100%;">
        <med-datepicker
          size="small"
          [mode]="'range'"
          label="Фактична дата"
          placeholder="Оберіть дату"
          [(ngModel)]="filter.supplies.actualDate"
          (onInput)="filter.suppliesStateChanged()"
        ></med-datepicker>
      </div>
      <div style="width: 100%;">
        <med-multi-select
          size="small"
          [hideClearBtn]="true"
          placeholder="{{ !filter.supplies.warehouse.length ? 'Всі': 'Обрано фільтрів: ' + filter.supplies.warehouse.length }}"
          label="Склад партнера"
          [options]="filter.suppliesOptions.warehouses"
          [(ngModel)]="filter.supplies.warehouse"
          (ngModelChange)="filter.suppliesStateChanged()"
        ></med-multi-select>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Постачальник"
          label="Постачальник"
          [(ngModel)]="filter.supplies.supplier[0]"
          (focusout)="filter.suppliesStateChanged()"
        ></med-input>
      </div>
    </div>
  </div>
</p-sidebar>
<app-page-title></app-page-title>

<app-loader [hidden]="loadingCounter === 0"></app-loader>
  <div class="table-wrapper" [hidden]="loadingCounter > 0">
    <p-table
            #dt
            styleClass="p-datatable-sm"
            [scrollable]="true"
            scrollHeight="flex"
            [value]="tableBody"
            [customSort]="true"
            [lazy]="true"
            [resizableColumns]="true"
            columnResizeMode="expand"
            [columns]="tabHeader"
            [reorderableColumns]="true"
            (onLazyLoad)="loadData($event, true)"
            (onColReorder)="saveColumnOrder()"
    >
        <ng-template pTemplate="header">
            <tr>
                <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key"  [pSortableColumnDisabled]="column.key === 'directions' || column.key === 'subdirections' || column.key === 'name'" pReorderableColumn pResizableColumn
                    *ngFor="let column of tabHeader" style="min-width: 10em">
                    <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'max-width': ['deliveryDate'].includes(column.key) ? '14em': 'initial', 'width': ['deliveryDate'].includes(column.key) ? '10em': 'initial'}" [ngClass]="{'no-wrap': ['deliveryDate'].includes(column.key)}">
                        {{ column.label }}&nbsp;
                        <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-supply let-columns="columns"> 
            <tr class="table-content-text" (dblclick)="goToGoods(supply.supplyNum)">
              <ng-container *ngFor="let col of columns">
                <td style="word-break: keep-all; white-space: nowrap; color: #333333" *ngIf="col.key === 'agreementNum'">{{ supply.agreementNum }}</td>
                <td *ngIf="col.key === 'status'">
                    <div style="word-break: keep-all; white-space: nowrap; color: #333333">
                        <img [src]="getPathtpStatusImg(supply.status)" width="4" height="16" style="vertical-align: middle;"/>
                        &nbsp;
                        <span>{{ supply.status }}</span>
                    </div>
                </td>
                <td style="color: #666666" *ngIf="col.key === 'directions'">
                    <ul style="margin: 0; padding: 0;">
                        <li *ngFor="let direction of supply.directions" style="list-style-position: inside" class="truncate-15em">
                            {{ direction.shortName }}
                        </li>
                    </ul>
                </td>
                <td style="color: #666666" *ngIf="col.key === 'subdirections'">
                    <ul style="margin: 0; padding: 0;">
                        <li *ngFor="let subDirection of supply.subDirections" style="list-style-position: inside" class="truncate-15em">{{ subDirection }}</li>
                    </ul>
                </td>
                <td style="color: #666666" *ngIf="col.key === 'name'">
                    <ul style="margin: 0; padding: 0;">
                        <li *ngFor="let mnn of supply.mnnNames" style="list-style-position: inside" class="truncate-15em">{{ mnn }}</li>
                    </ul>
                </td>
                <td *ngIf="col.key === 'deliveryDate'">{{ supply.deliveryDate }}</td>
                <td *ngIf="col.key === 'actualDeliveryDate'">{{ supply.actualDeliveryDate }}</td>
                <td *ngIf="col.key === 'warehouseName'">{{ supply.warehouseName }}</td>
                <td *ngIf="col.key === 'supplierName'">{{ supply.supplierName }}</td>
                <td *ngIf="col.key === 'residency'">{{ supply.residency }}</td>
                <td *ngIf="col.key === 'budgetYear'">{{ supply.budgetYear }}</td>
                <td *ngIf="col.key === 'budgetName'">{{ supply.budgetName }}</td>
                <td *ngIf="col.key === 'supplyNum'">{{ supply.supplyNum }}</td>
                <td style="word-break: keep-all; white-space: nowrap;" *ngIf="col.key === 'logisticManager'">{{ supply.logisticManager }}</td>
              </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex flex-center flex-between">
                <med-pagination
                        [total]="totalRows"
                        [page]="selectedPageNumber"
                        [perPage]="pageSize"
                        (pageChange)="pageChange($event)"
                ></med-pagination>

                <div class="small-text">
                    Показано &nbsp;<span style="color: #000000" class="h10-text">{{ getFirstShowedRowIndex() }}-{{ getFirstShowedRowIndex() + pageSize }}</span> &nbsp;з {{ totalRows }}
                </div>

                <div>
                    <span class="small-text">Кількість на сторінку</span>
                    <med-radio-group
                            mode="buttons"
                            [value]="showedOnPage"
                            [options]="paginationOptions"
                            (onInput)="pageSizeChanged($event)"
                    ></med-radio-group>
                </div>
            </div>
        </ng-template>
    </p-table>
</div>
